module.exports = __webpack_public_path__ + "ubisoft_plus-fc-desktop.jpg";